










































import { defineComponent, PropType, ref, onMounted, onUnmounted, useContext } from '@nuxtjs/composition-api';
import { throttle } from 'lodash-es';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { SMARTPHONE } from '~/constants/breakpoint';
import { url } from '~/utils';
import { FilterCategoryList } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
  },
  props: {
    sortedCategories: {
      type: Array as PropType<FilterCategoryList[]>,
      required: true,
    },
  },
  setup() {
    const { app } = useContext();
    const heightExcludingHeader = ref(0);
    const isMenuOpen = ref(false);
    const isSmartPhone = ref(app.$ua.deviceType() === SMARTPHONE);

    const handleMenuOpen = () => {
      isMenuOpen.value = !isMenuOpen.value;
      if (isMenuOpen.value) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    };

    const onClickLink = () => {
      // アプリの場合は遷移後スクロールできるなるなるので↓削除
      document.body.classList.remove('overflow-hidden');
      isMenuOpen.value = false;
    };

    // スクロールによるヘッダー・タブバーの非表示挙動がついかされたためリアルタイムで高さを計算する
    const updateMenuHeight = throttle(() => {
      const articleHeaderRec = document.getElementById('article-header-wrapper')?.getBoundingClientRect();
      if (!articleHeaderRec) return;
      heightExcludingHeader.value = window.innerHeight - articleHeaderRec.bottom;
    }, 100);
    onMounted(() => {
      updateMenuHeight();
      if (isSmartPhone.value) {
        window.addEventListener('scroll', updateMenuHeight);
      }
    });
    onUnmounted(() => {
      if (isSmartPhone.value) {
        window.removeEventListener('scroll', updateMenuHeight);
      }
    });

    return {
      isMenuOpen,
      url,
      handleMenuOpen,
      onClickLink,
      heightExcludingHeader,
    };
  },
});
